import { styled } from '@porsche-code/kado-styled-system/jsx';
import type { Descendant } from 'platejs';
import { useEditorState } from 'platejs/react';
import { useMemo } from 'react';

import { transformRichTextToString } from './transformRichTextToString';

const Container = styled('div', {
  base: {
    color: 'text.contrastMedium',
    paddingLeft: 'sm',
  },
});

export const getRichTextCharacterCount = (nodes: Descendant[]): number =>
  transformRichTextToString(nodes).length ?? 0;

export const CharacterCounter = () => {
  const editor = useEditorState();

  const value = editor.children;
  const count = useMemo(
    () => getRichTextCharacterCount(value as Descendant[]),
    [value],
  );

  return <Container>{count}</Container>;
};
